import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
// import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export interface useValidarCotacaoInterface {
  IdCotacao: string;
}

export function useValidarCotacao(
  props: useValidarCotacaoInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const VALIDAR_COTACAO = `${backofficeEnviroment}/common/oportunidades-lead/validar-cotacao/v1/${props.IdCotacao}`;
    const response = await instance.get(VALIDAR_COTACAO);
    return response?.data;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: false,
    onError: (error: any) => {
      return error.response.data.notifications?.[0].message;
    },
  });
  return query;
}
